const gameAliases = {
  Bandido: ['BandidoDice'],
  CherryBlast: ['CherryBlast90', 'CherryBlastDice', 'CherryBlastStreamer', 'CherryXmass'],
  DueloMahjong: ['DueloMahjong90', 'DueloMahjongDice'],
  EmberInferno: ['EmberInfernoDice'],
  EmpireOfTheTiger: ['EmpireOfTheTigerDice'],
  FishyCatch: ['FishyCatchDice'],
  FishyGuy: ['FishyGuy90', 'FishyGuyDice', 'FishyGuyStreamer'],
  GoldOfEgypt: ['GoldOfEgypt90', 'GoldOfEgypt98', 'GoldOfEgyptDice', 'GoldOfEgyptStreamer'],
  JokersFortune: ['JokersFortuneDice'],
  JokersShow: ['JokersShow90', 'JokersShowDice'],
  KraljBalkana: ['BalkanKing', 'BalkanKingDice'],
  NedAndTed: ['NedTed', 'NedTedDice'],
  PremierSlot: ['777WildStar', '777WildStar90', '777WildStarDice', 'PremierJackpot'],
  RandysRevenge: ['RandysRevengeDice'],
  SugarBlast: ['SugarBlast90', 'SugarBlastStreamer', 'SugarDice'],
  SuperCup: ['BetanoGame', 'WorldFootballx2026'],
  Supernova: ['Supernova90', 'SupernovaDice', 'SupernovaStreamer'],
  TaleOfGems: ['TaleOfGemsDice'],
  TolucaFortune: ['TolucaFortune90', 'TolucaFortuneDice', 'TolucaFortuneStreamer'],
};

export function resolveGameName(gameName) {
  const aliasEntry = Object.entries(gameAliases).find((aliases) => aliases[1].includes(gameName));
  return aliasEntry ? aliasEntry[0] : gameName;
}

export function resolveDisplayName(backendDisplayName) {
  const suffixes = ['90', '98'];

  for (let i = 0; i < suffixes.length; i++) {
    if (backendDisplayName.endsWith(suffixes[i])) {
      return backendDisplayName.slice(0, -suffixes[i].length).trim();
    }
  }

  return backendDisplayName;
}
